type Props = {
  size?: number;
  inline?: boolean;
  invert?: boolean;
};

export default function LogoSpinner({ size = 48, inline = false, invert = false }: Props) {
  const img = (
    <picture>
      <source srcSet="/logo-knot-lg.avif" type="image/avif" />
      <source srcSet="/logo-knot-lg.webp" type="image/webp" />
      <img
        src="/logo-knot-lg.png"
        alt=""
        width={size}
        height={size}
        style={{
          width: size,
          height: size,
          animation: 'swz-spin 1.4s linear infinite',
          filter: invert ? 'brightness(0)' : 'none',
        }}
      />
    </picture>
  );

  if (inline) {
    return (
      <>
        {img}
        <style>{`@keyframes swz-spin { to { transform: rotate(360deg) } }`}</style>
      </>
    );
  }

  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center gap-4">
      {img}
      <span className="font-sans text-[13px] tracking-[2px] text-brand-muted">
        swiss<span className="text-brand-cyan">ez</span>
      </span>
      <style>{`@keyframes swz-spin { to { transform: rotate(360deg) } }`}</style>
    </div>
  );
}
